var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{staticClass:"app-overlay",attrs:{"value":!!_vm.overlayComponent,"dark":false}},[_c(_vm.overlayComponent,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }